@layer design-system {
  .table {
    tr {
      background-color: var(--background-default);

      td {
        background-color: var(--background-default);
      }
    }
  }

  .headerSticky {
    th {
      position: sticky;
      top: 0;
      z-index: var(--z-index-smarttable-sticky-header-cell);
    }

    .stickyTableHeader {
      z-index: calc(var(--z-index-smarttable-sticky-header-cell) + 1);
    }
  }

  .stickyTableHeader {
    position: sticky;
    left: 0;
    z-index: calc(var(--z-index-smarttable-sticky-header-cell) + 1);
  }

  .stickyTableHeaderBorder {
    border-right: 1px solid var(--border-default);
  }

  .stickyTableCell {
    position: sticky;
    left: 0;
    display: flex;
    gap: 12px;
    background-color: var(--background-default);
  }

  .stickyTableCellBorder {
    border-right: 1px solid var(--border-default);
  }

  .actionTableCell {
    > div {
      visibility: hidden;
    }
  }

  .styledTableRow:hover {
    .actionTableCell {
      > div {
        visibility: visible;
      }
    }
  }
}
